import { useEffect, useState } from 'react'
import { getDisplayMode } from './useIsPwa.helpers'

export const useIsPwa = () => {
  const [isPwa, setIsPwa] = useState(
    'standalone' === getDisplayMode().displayMode
  )

  useEffect(() => {
    const { standaloneMatcher } = getDisplayMode()
    const listener = (ev: MediaQueryListEvent) => {
      setIsPwa(ev.matches)
    }
    standaloneMatcher.addEventListener('change', listener)

    return () => {
      standaloneMatcher.removeEventListener('change', listener)
    }
  }, [])

  return {
    isPwa
  }
}
